'use strict'

const CONSTANTS = require('../constants/constants');
const BaseAnalyticsBuilder = require('./baseAnalyticsBuilder');

class DetailsAnalyticsBuilder extends BaseAnalyticsBuilder{

  constructor() {
    super();
    this.detailViewEventUrl = $('body .js-ga4-dataset').data('viewevent');
  }

  /**
   * This function will attach analytics events to current page
   */
  attachAnalytics() {
    //Attach base events
    super.attachAnalytics();

    //Attach all detail page triggers
    this.attachSpecificTriggers();
  }


  /**
   * This function exposes triggers to element inside current page
   */
  attachSpecificTriggers(){
    $(document).on(CONSTANTS.EVENT_CONSTANTS.PDP.EVENTS.SELECT_SIZE, {url : this.detailViewEventUrl}, selectSizeEvent);
    $('.js-zoom-image').on('click', {name : CONSTANTS.EVENT_LIST_NAME.SELECT_IMAGE}, pushEventNameOnly);
    $(document).on('click', '#productAdditionalInfo > div', detailSelection);
    attachColorSelectionViewProductEvent(this.detailViewEventUrl);
    viewProductEvent(this.detailViewEventUrl);

    // Retailtune event
    var retailTuneModal = $('#modalFindInStore');
    if (typeof dataLayer !== 'undefined') {
      retailTuneModal.on('shown.bs.modal', function (event) {
        var productId = $('#product-id-sku')?.text()?.split('|')[0];

        dataLayer.push({
          event: "generic_event",
          event_category: "find_in_store",
          event_label: productId
        });
      });
    }
  }
}

/**
 * PRIVATE FUNCTIONS
 */
/**
 * View PDP product event
 * @param {string} url - Google-GetProductData endpoint
 * @param {string} [productOverride] - Optional resolved product id
 * @param {boolean} [pushToFlutter] - True to forward view_item to mobile wrapper
 */
function viewProductEvent(url, productOverride, pushToFlutter){

  if(typeof dataLayer !== 'undefined' && url){
        
    var product = productOverride;

    if (!product) {
      let color = $('.color-attribute .selected').data('attr-value');
      let size = $('.size-attribute .selected').data('attr-value');
  
      if (color && size) {
        // If edit are made, update also cartridges/app_custom_cisalfa/cartridge/templates/default/loyaltyapp/components/producttopcontent.isml
        var colorSplitted = color.split('-');
        var colorString = (color.endsWith("--") && (colorSplitted[1] == "" || colorSplitted[1] == undefined)) ? "-" : (colorSplitted.length > 2 ? (color.replace(colorSplitted[0] + "-", "")) : colorSplitted[1]);
        product = `${colorSplitted[0]}|${colorString}|${size}`
      } else {
        product = $('#product-id-sku').text();
      }
    }

    if (!product) return;
  
    url = url.split('productString')[0] + 'productString=' + product;
  
    //STEP 1: Update cart
    $.ajax({
      type: 'GET',
      url: url,
      success: function (data) {
        //STEP 1: Check data existence
        if (!data || !data.eventData){
          console.error('PDP view analytics failed');
          return;
        }
  
        //STEP 2: Build and push data to analytics
        dataLayer.push({
          event : CONSTANTS.EVENT_LIST_NAME.VIEW_PRODUCT,
          ecommerce : data.eventData
        });

        if (pushToFlutter) {
          pushViewItemToFlutter(data.eventData, product);
        }
      },
    });
  }
}

/**
 * Sends the same view_item payload to mobile analytics wrapper when available.
 * @param {Object} eventData - Ecommerce payload returned by Google-GetProductData
 * @param {string} productVariation - Product variation id used for controller lookup
 */
function pushViewItemToFlutter(eventData, productVariation) {
  if (typeof window.analyticsWrapper !== 'function' || !eventData || !productVariation) {
    return;
  }

  try {
    var datasetElement = document.querySelector('.js-ga4-dataset');
    var flutterDataUrl = datasetElement ? datasetElement.getAttribute('data-productdata-flutter') : '';
    if (!flutterDataUrl) {
      return;
    }

    var currentLocale = document.documentElement && document.documentElement.lang
      ? document.documentElement.lang
      : 'it';

    var url = flutterDataUrl;
    if (url.indexOf('productString=') > -1) {
      url = url.replace(/productString=[^&]*/, 'productString=' + encodeURIComponent(productVariation));
    } else {
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'productString=' + encodeURIComponent(productVariation);
    }

    $.ajax({
      type: 'GET',
      url: url,
      success: function (response) {
        if (!response || !response.products || !response.products.length) {
          console.error('PDP app view_item analytics failed: invalid flutter payload');
          return;
        }

        window.analyticsWrapper('detail', {
          ecommerce: {
            currencyCode: 'EUR',
            detail: {
              actionField: {
                list: 'search'
              },
              products: response.products
            }
          }
        }, 'true', currentLocale);
      },
      error: function () {
        console.error('PDP app view_item analytics failed: flutter endpoint error');
      }
    });
  } catch (error) {
    console.error('PDP app view_item analytics failed');
  }
}

/**
 * Pushes a view_item event when a color swatch is clicked on PDP.
 * The event is deferred until variant resolution to use the resolved product id.
 * @param {string} url - Google-GetProductData endpoint
 */
function attachColorSelectionViewProductEvent(url){

  var isColorSelectionPending = false;

  $(document).on('click', '.cc-pdp__color-attribute', function () {
    var isAlreadySelected = $(this).attr('aria-checked') === 'true' || $(this).find('.swatch-value').hasClass('selected');
    if (isAlreadySelected) {
      isColorSelectionPending = false;
      return;
    }

    isColorSelectionPending = true;
  });

  $('body').on('product:afterAttributeSelect', function (event, response) {

    if(!isColorSelectionPending)
      return;

    isColorSelectionPending = false;

    if(!response || response.isSizeAttribute || !response.data || !response.data.product || !response.data.product.id)
      return;

    viewProductEvent(url, response.data.product.id, true);
  });
}


/**
 * Size selection event push
 * @param event
 * @returns {boolean}
 */
function selectSizeEvent(event){

  if(typeof dataLayer !== 'undefined'){
        
    event.preventDefault();
  
    let url = event.data.url
  
    let variant = {}
    if(sessionStorage.getItem('selectSizeEvent')){
      variant = JSON.parse(sessionStorage.getItem('selectSizeEvent'));
      let color = variant.color.split('-')[0] + '|' + variant.color.split('-')[1]
      url += `&variant=${color}|${variant.size}`
    }
  
  
    //STEP 1: Update cart
    $.ajax({
      type: 'GET',
      url: url,
      success: function (data) {
        //STEP 1: Check data existence
        if (!data || !data.eventData){
          console.error('Product size view analytics failed');
          return;
        }
  
        //STEP 2: Build and push data to analytics
        dataLayer.push({
          event : CONSTANTS.EVENT_LIST_NAME.SELECT_SIZE,
          ecommerce : data.eventData
        });
  
      },
    });
  }
}


/**
 * Function used for name only events
 * Event name will be retrived by element class name
 * @returns {boolean}
 */
function pushEventNameOnly(event){

  if(typeof dataLayer !== 'undefined'){
        
    //STEP 1: Check event name
    var name;
    if(event.data && event.data.name && event.data.name !== '')
      name = event.data.name;
    else if($(this).hasClass('swatch-circle'))
      name = CONSTANTS.EVENT_LIST_NAME.SELECT_SIZE;
  
  
    if(!name){
      console.error('Impossible to send GA4 event: name is missing');
      return false;
    }
  
    //STEP 2: Push event name
    dataLayer.push({
      event : name
    });
  }

}


/**
 * Detail selection push
 * @returns {boolean}
 */
function detailSelection(){

  if(typeof dataLayer !== 'undefined'){
        
    //STEP 1: Check asset value
    var assetName = $(this).attr('id');
    if(!assetName){
      console.error('Impossible to send GA4 details click: missing asset');
      return false;
    }
  
    var assetValue = CONSTANTS.EVENT_CONSTANTS.PDP.ASSETS[assetName];
  
    if(!assetValue) {
      console.error('No values found for current asset: failed to push detail event');
      return false;
    }
  
    //STEP 2: Push event name
    dataLayer.push({
      event : CONSTANTS.EVENT_LIST_NAME.SELECT_DETAILS,
      detail_type : assetValue
    });
  }
}

module.exports = DetailsAnalyticsBuilder;
